import { type } from "arktype";
import { AdaptationHypothesis, Challenge, Consideration, Question, SessionPlan } from "./reasoning";
import { Goal, GoalCheckIn } from "./client";

// R-OVR-01 order: goal → what matters now → recently → open question(s) → today's session → considerations → challenge count.
export const OverviewSnapshot = type({
  clientId: "string",
  computedAt: "string",
  header: { name: "string", frequencyText: "string", dateText: "string", challengeCount: "number" },
  goal: { goal: Goal, "lastCheckIn?": GoalCheckIn, checkInStatus: "'on_track' | 'due' | 'overdue'", "overdueDays?": "number", "strategyIntent?": "string" },
  whatMattersNow: AdaptationHypothesis.array(),
  recently: type({ id: "string", layer: "'fact' | 'signal'", text: "string", at: "string" }).array(),
  openQuestions: Question.array(),
  todaysSession: SessionPlan.or("null"),
  considerations: { visible: Consideration.array(), total: "number" },
  challenges: Challenge.array(),
  "intakeNudge?": "string | null",
  "escalation?": "unknown",
});
export type OverviewSnapshot = typeof OverviewSnapshot.infer;
